export default __webpack_public_path__ + "static/media/AnimalPage4.520edaa5.txt";